import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  type SupplierRequestsQueryParams,
  type SupplierRequestsResponse,
} from './types';
import {
  zodSupplierRequestsQueryParamsSchema,
  zodSupplierRequestsResponseSchema,
} from './validations';

/**
 * Fetches the caller's own supplier requests as a paginated list.
 *
 * All query parameter keys are camelCase and are automatically converted to
 * snake_case by the ky case-converter before the request is sent.
 *
 * @param queryParams - The company account ID and optional state filter and pagination parameters.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The paginated supplier requests response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_supplier_requests_suppliers_requests_get
 */
export const fetchSupplierRequests = async (
  queryParams: Partial<SupplierRequestsQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_REQUESTS(), {
      ...options,
      searchParams: queryParams,
      validate: {
        response: zodSupplierRequestsResponseSchema,
        searchParams: zodSupplierRequestsQueryParamsSchema.transform((value) =>
          withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
        ),
      },
    })
    .json<SupplierRequestsResponse>();
